import { ProviderMeta } from '@shared/providers/provider-meta';
import { DataField } from '@shared/providers/types';

const hubspotIdPattern = /^[1-9]\d*$/;

class HubspotMeta implements ProviderMeta {
  getIdFieldLength(): number {
    return 20;
  }
  getIdFieldName(): string {
    return 'hs_object_id';
  }

  getIdFieldlabel(): string {
    return 'record id';
  }

  isIdValue(value: string): boolean {
    return hubspotIdPattern.test(value);
  }

  getDataFieldFromHeader(header: string): DataField {
    return { name: header, label: header, type: 'string' } as DataField;
  }
}

export default HubspotMeta;
